import _ from 'lodash';
import React, { useMemo } from 'react';
import connect from 'components/lib/connect';

export const TeamsContext = React.createContext([]);

function TeamsContextProvider({ teams, teamsImmutable, children }) {
  const value = useMemo(() => {
    return memoizedTeams(teams);
  }, [teamsImmutable]);

  return <TeamsContext.Provider value={value}>{children}</TeamsContext.Provider>;
}

function memoizedTeams(teams) {
  return _(teams)
    .map(team => ({
      id: team.id,
      name: team.name,
      agentIds: new Set(team.agentIds),
      agentsCount: team.agentIds.length,
    }))
    .sortBy(team => team.name.toLowerCase())
    .value();
}

const TeamsProvider = connect(mapStateToProps)(TeamsContextProvider);

function mapStateToProps({ getProvider }) {
  let teamsProvider = getProvider('teams');
  return {
    teams: teamsProvider.findAll(),
    teamsImmutable: teamsProvider.immutableStore.binding.get(),
  };
}

export default TeamsProvider;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/teams_provider.jsx